const $ = window.jQuery;
const SELECTOR = '.filtered-link-list';
const PAGE_SIZE = 24;

function onDocumentReady() {
	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	const $el = $(el);
	const jobs = $el.find('.jobs-collection');
	const json = jobs.data('jobs');

	$el.data('jobs', json);
	$el.on('change', '.link-filter', onChangeFilter);
	$el.on('keyup', '[name="search"]', onChangeSearch);
	$el.on('click', '.page', onClickPage);

	setElementFilter($el, {});

	$el.addClass('initialized');
}

function onClickPage(e) {
	const clicked = $(e.currentTarget);
	const $el = clicked.closest(SELECTOR);
	const filter = getElementFilter($el);
	const n = clicked.data('page');

	filter.page = parseInt(n, 10);
	setElementFilter($el, filter);
}

function onChangeFilter(e) {
	const select = $(e.currentTarget);
	const $el = select.closest(SELECTOR);
	const filter = getElementFilter($el);

	filter[select.attr('name')] = select.val();
	filter.page = 0;

	setElementFilter($el, filter);
}

function onChangeSearch(e) {
	const input = $(e.currentTarget);
	const $el = input.closest(SELECTOR);

	let filter = getElementFilter($el);
	filter[input.attr('name')] = input.val();
	filter.page = 0;

	setElementFilter($el, filter);
}

function getElementFilter($el) {
	return $el.data('filter') || {};
}

function jobMatchesFilter(job, filter) {
	const matchDep = !filter.department || (filter.department === job.department);
	const matchLoc = !filter.location || (filter.location === job.location);
	const matchSearch = !filter.search || job.title.toLowerCase().match(filter.search.toLowerCase());

	return matchDep && matchLoc && matchSearch;
}

function jobLink(job) {
	return $(`<a href="?gh_jid=${job.id}" class="jobs-collection-item link">
		<div class="department">${job.department}</div>
		<div class="title">${job.title}</div>
		<div class="red-link">Learn More</div>
	</a>`);
}

function getPagination(totalPages, currentPage) {
	if (totalPages <= 1) {
		return false;
	}

	const prev = `<button data-page="${Math.max(0, currentPage - 1)}" class="previous page ${currentPage === 0 ? 'disabled' : ''}"></button>`;
	const next = `<button data-page="${Math.min(totalPages - 1, currentPage + 1)}" class="next page ${currentPage === totalPages - 1 ? 'disabled' : ''}"></button>`;
	const page = n => `<button data-page="${n}" class="page ${n === currentPage ? 'current' : ''}">${n+1}</button>`;
	const pages = [ prev ];
	for (let i=0; i<totalPages; i++) {
		pages.push(page(i));
	}
	pages.push(next);

	return $(`<div class="pagination" data-total-pages="${totalPages}" data-page="${currentPage}">${pages.join('')}</div>`);
}

function setElementFilter($el, filter) {
	const jobsData = $el.data('jobs');
	const passedFilter = jobsData.filter(j => jobMatchesFilter(j, filter));
	const pageCount = Math.ceil(passedFilter.length / PAGE_SIZE);
	const page = filter.page || 0;
	const offset = page * PAGE_SIZE;
	const end = Math.min(passedFilter.length, offset+PAGE_SIZE);
	const pagination = getPagination(pageCount, page);

	const jobEls = [];
	for(let i=offset; i<end; i++) {
		const link = jobLink(passedFilter[i]);
		jobEls.push(link);
	}

	if (pagination) {
		jobEls.push(pagination);
	}

	const coll = $el.find('.jobs-collection');
	coll.html('').append(jobEls);

	jobEls.forEach((el, n) => {
		$(el).css('opacity', 0).delay(n * 150).animate({ opacity: 1 });
	})

	if (!coll.html()) {
		coll.html('<p class="no-results">No results found. Please try adjusting the filter.</p>');
	}

	$el.data('filter', filter);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
